import axios from "axios";

export const privacyData = () => {
  return axios
    .get("/privacy")
    .then((response) => {
      // console.log(response.data);
      return response;
    });
};